var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('h1',{staticClass:"py-10"},[_vm._v(_vm._s(_vm.$t("Select an account")))]),_c('Companies')],1)}
var staticRenderFns = []

export { render, staticRenderFns }